import {Component, OnInit} from '@angular/core';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {UserExperienceHttpService} from '../../../services/http-services/user-experience/user-experience-http.service';
import {GrUserExperience} from '../../../services/http-services/user-experience/user-experience-http-interfaces';
import {GetFaqApiDataFormatted} from '../../../services/http-services/faq/faq-http-interfaces';
import {GrFaq} from '../../../interfaces/faq-interfaces';
import {GrPagination} from '../../../interfaces/general-interfaces';
import {FaqHttpService} from '../../../services/http-services/faq/faq-http.service';
import {FaqEnums} from '../../../enums/faq-enums';
import {GeneralHttpService} from '../../../services/http-services/general/general-http.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {EmailRegex} from '../../../constants/general-variables';
import {ToastrService} from 'ngx-toastr';
import {BannersHttpService} from '../../../services/http-services/banners/banners-http.service';
import {GrBanner} from '../../../interfaces/banners-interfaces';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
  userExperiences: GrUserExperience[] = [];
  hoveredCategoryBanner?: GrBanner;
  banners: Record<string, GrBanner[]> = {};
  businessPartners = [0, 1, 2];
  faqs: GrFaq[] = [];
  newsletterForm!: FormGroup;
  newsletterFormTriedToSubmit = false;
  faqPagination: GrPagination | undefined;
  activeFaqIndex = 0;
  urlParams: any = {type: FaqEnums.userForDB, search: null};
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(private userExperienceHttpService: UserExperienceHttpService,
              private generalHttpService: GeneralHttpService,
              private bannersHttpService: BannersHttpService,
              private formBuilder: FormBuilder,
              private toastService: ToastrService,
              private faqHttpService: FaqHttpService) {
  }

  ngOnInit(): void {
    this.getBanners();
    this.getUserExperiences();
    this.getFaqs();
    this.buildForm();
  }

  buildForm(): void {
    this.newsletterForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(EmailRegex)]],
    });
  }

  getBanners(): void {
    this.bannersHttpService.getLandingWebBanners({bannerTypes: 'a,b,c'}).then(res => {
      this.banners = res.data;
      this.hoveredCategoryBanner = res.data.A[0];
    });
  }

  getFaqs(): void {
    const page = (this.faqPagination?.currentPage) ? this.faqPagination.currentPage : 1;
    this.faqHttpService.getLandingFaqs({page, ...this.urlParams}).then((res: GetFaqApiDataFormatted) => {
      this.faqs = res.data;
      this.faqPagination = res.pagination;
    });
  }

  getUserExperiences(): void {
    this.userExperienceHttpService.getLandingUserExperiences().then(res => {
      this.userExperiences = res.data;
    });
  }

  onSubmitPostNewsletterForm(): any {
    this.newsletterFormTriedToSubmit = true;
    if (this.newsletterForm.valid) {
      this.generalHttpService.postNewsletter(this.newsletterForm.value).then((res: any) => {
        this.toastService.success(res.message);
        this.newsletterFormTriedToSubmit = false;
        this.newsletterForm.reset();
      }).catch(error => {
        this.toastService.error(error.error.message);
      });
    }
  }
}
